import { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthentication from './authenticationService';
import { LayoutContext } from '../Context/LayoutContext';
const RoleWrapper = ({ children }) => {
  const [redirect, setRedirect] = useState(false);
  const { setCurrentUserRole, setUserInformation, companyInfoLoaded } = useContext(LayoutContext);
  const { user, error } = useAuthentication();
  useEffect(() => {
    if (localStorage.getItem('isLoggedIn') !== 'true') {
      setRedirect(true);
    } else if (companyInfoLoaded) {
      setCurrentUserRole(user?.RoleID);
      setUserInformation(user);
    }
  }, [user, error, companyInfoLoaded]);
  if (redirect) {
    return <Navigate to="/" replace />;
  } else {
    return children;
  }
};

export default RoleWrapper;
